import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getVotesFailed,
  getVotesStart,
  getVotesSuccess,
} from "../redux/getVotes";

import { getVotesApi } from "core/http/service/internalEvents";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";

function* getVotesWork(action: ReturnType<typeof getVotesStart>) {
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));

  try {
    const res = yield call(getVotesApi, {
      offset,
      limit,
      awardId: action.payload.awardId,
    });

    yield put({
      type: getVotesSuccess.type,
      payload: {
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getVotesFailed.type,
    });
  }
}

function* watchGetVotes() {
  yield takeEvery(getVotesStart.type, getVotesWork);
}

export default function* getVotesSaga() {
  yield all([watchGetVotes()]);
}
